export { PricingTierEditor, useTierLogic } from './entries/bootstrap';



//////////////////
// WEBPACK FOOTER
// ./src/components/PricingTier/index.tsx
// module id = 1018
// module chunks = 0